export function formatCurrency(value, currency = 'USD', locale = null) {
  const computedLocale = locale ?? navigator?.language ?? 'en-US'
  return value.toLocaleString(computedLocale, {
    style: 'currency',
    currency,
  })
}

export function formatCents(value, currency = 'USD', locale = null) {
  return formatCurrency(centsToDecimal(value), currency, locale)
}

export function formatCentsWithoutCurrencySymbol(value) {
  return centsToDecimal(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function getCurrencySymbol(currency = 'USD', locale = null) {
  const computedLocale = locale ?? navigator?.language ?? 'en-US'
  return (0)
    .toLocaleString(computedLocale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, '')
    .trim()
}

export function centsToDecimal(value) {
  return Math.round((value / 100) * 100) / 100
}

export function decimalToCents(value) {
  return Math.round(value * 100)
}

export function currencyToCents(value) {
  if (typeof value === 'number') {
    return Math.round(value * 100)
  }

  if (!value || typeof value !== 'string') {
    return 0
  }

  // Remove currency symbols, letters, and whitespace
  let cleaned = value.replace(/[^\d,.-]/g, '')

  if (!cleaned) {
    return 0
  }

  // Handle negative numbers
  const isNegative = cleaned.startsWith('-') || value.includes('(')
  cleaned = cleaned.replace('-', '')

  // Find positions of last comma and last period
  const lastComma = cleaned.lastIndexOf(',')
  const lastPeriod = cleaned.lastIndexOf('.')

  let decimalSeparator = null

  if (lastComma === -1 && lastPeriod === -1) {
    // No separators - treat as whole number
    decimalSeparator = null
  } else if (lastComma === -1) {
    // Only periods - check if it's a decimal or thousands separator
    const periodCount = (cleaned.match(/\./g) || []).length
    const afterPeriod = cleaned.substring(lastPeriod + 1)
    if (periodCount === 1 && afterPeriod.length <= 2) {
      decimalSeparator = '.'
    }
  } else if (lastPeriod === -1) {
    // Only commas - check if it's a decimal or thousands separator
    const commaCount = (cleaned.match(/,/g) || []).length
    const afterComma = cleaned.substring(lastComma + 1)
    if (commaCount === 1 && afterComma.length <= 2) {
      decimalSeparator = ','
    }
  } else {
    // Both separators present - the last one is the decimal separator
    decimalSeparator = lastComma > lastPeriod ? ',' : '.'
  }

  // Remove thousands separators and normalize decimal separator
  if (decimalSeparator === ',') {
    cleaned = cleaned.replace(/\./g, '').replace(',', '.')
  } else if (decimalSeparator === '.') {
    cleaned = cleaned.replace(/,/g, '')
  } else {
    cleaned = cleaned.replace(/[,.]/g, '')
  }

  const parsed = parseFloat(cleaned) || 0
  const cents = Math.round(parsed * 100)

  return isNegative ? -cents : cents
}
